import { StyledTag } from '@app/components/tag/Tag';
import { interactionTypeColours } from '@app/utils/constants';

type InteractionTypeTagProps = {
    interaction: 'Call' | 'Email' | 'Whatsapp' | 'Live-chat';
};
const interactionKeys: Record<
    InteractionTypeTagProps['interaction'],
    keyof Omit<typeof interactionTypeColours, 'total'>
> = {
    Call: 'call',
    Email: 'email',
    Whatsapp: 'whatsapp',
    'Live-chat': 'livechat',
};

const InteractionTypeTag = ({ interaction }: InteractionTypeTagProps) => {
    const key = interactionKeys[interaction];
    const colour = interactionTypeColours[key];

    const style = {
        color: `color-mix(in srgb, ${colour} 90%, #000 10%)`,
        borderColor: colour,
        background: '#ffffff',
        letterSpacing: 0.5,
    };
    return (
        <StyledTag type="secondary" style={style}>
            {interaction}
        </StyledTag>
    );
};

export default InteractionTypeTag;
